export enum CustomerProductPlanType {
  Subscription = 'subscription',
  Perpetual = 'perpetual',
}
